/**
 * Created by richardlovejoy on 2/12/17.
 */
import _ from 'underscore';

import Phaser from 'phaser';
import AnimHelpers from '../utils/misc/AnimHelpers';
import TimeHelpers from '../utils/misc/TimeHelpers';
import SpritePool from '../utils/display/SpritePool';

import {MachineConstants, viewToPhysics, viewPositionToPhysics} from '../constants/MachineConstants';
import SkeeballPhysics from './SkeeballPhysics';
//import THREEScene3D from './scene/THREEScene3D';
import PhantomScene3D from './scene/PhantomScene3D';
import Camera from './scene/Camera';
import BallDispenser from './BallDispenser';
import FrontBallMeter from './meters/FrontBallMeter';
import CupSparkle from './effects/CupSparkle';
import BonusCupShimmer from './effects/BonusCupShimmer';
import BonusScoreMeter from './meters/BonusScoreMeter';
import TopBar from './TopBar';
import GameSounds from '../sound/GameSounds';

import LogicCore from '../logic/LogicCore';

// Trailer ball class
const TrailerBall = function(game) {

  Phaser.Image.call(this, game, 0, 0, 'skee', 'ballHighlight.png', null);

  this.visible = false;
  this.anchor.set(0.5);

};
TrailerBall.prototype = Object.create(Phaser.Image.prototype);

/////////////////////////////////////////////////////////////////////////
// CONSTRUCTOR //////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const GameScreen = function(game) {

  Phaser.Group.call(this, game);
  this.name = 'GameScreen';

  // signals
  this.onSignalAwardSequenceFinished = new Phaser.Signal();
};

/////////////////////////////////////////////////////////////////////////
// CONSTANTS ////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
GameScreen.USE_3D = (typeof THREEScene3D !== 'undefined');
GameScreen.BASE_CUP_DEPTH = 3;
GameScreen.TOP_BAR_HEIGHT = 88;

/////////////////////////////////////////////////////////////////////////
// MEMBERS ////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
GameScreen.prototype = _.extend( Object.create( Phaser.Group.prototype ), {

  constructor: GameScreen,

  /**
   *
   */
  init: function() {

    // create a 3D Scene with Machine objects in playcanvas 3D view coords
    var objects = this._createMachineObjects()
    this.threeScene = (GameScreen.USE_3D) ? Object.create(THREEScene3D).init(objects, Camera, 1024, 675) : null;
    this.phantomScene = Object.create(PhantomScene3D).init(objects, Camera, 1024, 675);

    // create a physics world from the objects
    this.physics = this._createPhysics(objects);


    // the board image
    this.skeeboard = this.game.add.image(0, GameScreen.TOP_BAR_HEIGHT, 'skeeboard', null, this);

    // backboard
    this.backboard = this.game.add.image(0, GameScreen.TOP_BAR_HEIGHT, 'skee', 'cupsAll.png', this);
    // scoreboard

    this.topBar = new TopBar(this.game);
    this.add(this.topBar);

    // cups and rings
    this.cupsRings = this._createCupsRings();

    // bonus score meter (right of machine
    this.bonusMeter = new BonusScoreMeter(this.game);
    this.add(this.bonusMeter);

    // ball dispenser
    this.dispenser = new BallDispenser(this.game, {sceneTHREE: this.threeScene, scenePhantom: this.phantomScene});
    this.add(this.dispenser);

    // ramp on top of dispenser
    this.ramp = this.game.add.image(0, 0, 'skee', 'ramp.png', this);

    // ramp lights
    this.rampLights = this.game.add.sprite(256, 319, 'skee', 'rampLights_000.png', this);
    const animData = [
      {label: 'runF', nameRoot: 'rampLights_', frame1: 0, frameLast: 13},
      {label: 'runR', nameRoot: 'rampLights_', frame1: 0, frameLast: 13, reverse: true},
      {label: 'runFR', nameRoot: 'rampLights_', frame1: 0, frameLast: 13, andReverse: true}
    ];
    AnimHelpers.addAnimationData(this.rampLights, animData);

    // ball meter on top of dispenser
    this.frontBallMeter = new FrontBallMeter(this.game);
    this.add(this.frontBallMeter);

    // cup effexts
    this.cupEffects = this._createCupEffects();

    // sparkle effects
    this.sparkleEffects = this._createSparkleEffects();
    //

    // bonus cup effect
    this.bonusCupEffects = this._createBonusCupEffects();

    // message pops
    this._createBonusAwardPops();

    // ball in play
    this.activeBall = null;

    // hidden initially
    this.visible = false;

    // trail
    this.trailPool = Object.create(SpritePool).init(this.game, 64, TrailerBall);

  }, // end Init

  reset: function() {

    // clear screen for a new game
    this.dispenser.reset();
    this.bonusMeter.reset();

  },

  frameUpdate: function() {

    // update physics
    var dt = this.game.time.elapsedSeconds;
    SkeeballPhysics.step(dt);

    // update balls in play
    if (this.activeBall) {
      this.activeBall.frameUpdate(dt);

    }

    // update dispenser
    this.dispenser.frameUpdate(dt);

    // update meters
    this.topBar.frameUpdate(dt);
    this.bonusMeter.frameUpdate(dt);

    // update 3d
    if (this.threeScene) {
      this.threeScene.render();
    }
    if (this.phantomScene) {
      this.phantomScene.render();
    }

    // render balls
    this.dispenser.renderBalls();
    if (this.activeBall) {
      this.activeBall.render();
    }

  },

  frameRender: function() {

  },

  runRampLights: function(pattern, count=0) {

    // pattern is:
    // F : forward
    // R : reverse
    // FR: forward then reverse
    this.rampLights.play('run'+pattern, 30, (count > 0));
    if (count > 0) {
      this.rampLights.animations.currentAnim.onLoop.add(() => {

        if (--count === 0) {
          this.rampLights.animations.currentAnim.stop();
        }
      })
    }
  },

  addActiveBall: function(ball) {

    // one active ball at a time
    this.add(ball);

    // exception if ball is not null
    if (this.activeBall) {
      console.log('EXCEPTION');
      this.game.logic.server.recordError('in-game', 'Overwrote active ball.');
    }

    this.activeBall = ball;
    this.activeBall.ready();
    this.activeBall.onSignalCupDepthZoneChanged.add(this._swapBallDepth, this);
  },

  removeActiveBall: function() {

    if (!this.activeBall)
      return;

    // remove listeners
    this.activeBall.onSignalCupDepthZoneChanged.remove(this._swapBallDepth, this);

    // set
    const ball = this.activeBall;

    // drop ball through hole, after it 'falls through', remove it
    ball.drop().add(() => {

      // done with it
      this.activeBall = null;
      this.dispenser.returnBall(ball);

    });
  },

  lightUpBonusCup: function(holeTag) {

    const cupEffect = _.findWhere(this.bonusCupEffects, {tag: holeTag});
    if (cupEffect) {

      cupEffect.fx.layer.addAt(this.bonusCupShimmer, 0);

      this.bonusCupShimmer.x = cupEffect.fx.x;
      this.bonusCupShimmer.y = cupEffect.fx.y;
      this.bonusCupShimmer.run();
    }
  },

  turnOffBonusCup: function() {
    this.bonusCupShimmer.stop();
  },

  showAward: function(award) {

    /*
    award = {
      points: 10,
      extraBalls: 3
    };
    */
    const cupEffect = _.findWhere(this.cupEffects, {tag: award.holeTag});
    cupEffect.fx.visible = true;
    cupEffect.fx.play('run', 30, false);

    const sparkleEffect = _.findWhere(this.sparkleEffects, {tag: award.holeTag});
    if (sparkleEffect.fx) {

      sparkleEffect.fx.layer.addAt(this.cupSparkle, 0);

      this.cupSparkle.x = sparkleEffect.fx.x;
      this.cupSparkle.y = sparkleEffect.fx.y;
      this.cupSparkle.run(award, this);
    }

    // hide bonus cup sparkle
    this.turnOffBonusCup();

    // sounds
    this.game.soundManager.playSound(GameSounds.SOUND_IN_HOLE);

    // win sound
    if (award.points > 10) {
      let winSound = GameSounds.SOUND_SMALL_WIN;
      if (award.points > 100) {
        winSound = GameSounds.SOUND_BIG_WIN;
      }
      else if (award.points > 30) {
        winSound = GameSounds.SOUND_MEDIUM_WIN;
      }

      this.game.soundManager.playSound(winSound);
    }

    // end
    setTimeout(() => this.onSignalAwardSequenceFinished.dispatch(), 1000);

    return this.onSignalAwardSequenceFinished;
  },

  draw: function() {
    const w = this.game.width;
    const h = this.game.height;
    const newScale = h / this.skeeboard.height;

    this.scale.set(newScale);

    // center
    this.x = (w - this.skeeboard.width * newScale) / 2;
    this.y = (h - this.skeeboard.height * newScale) / 2;

    if (this.threeScene) {
      const canvasHeight = parseFloat(this.game.canvas.style.height);
      const scaleFactor = canvasHeight / 675;
      this.threeScene.setSize(Camera, 1024 * scaleFactor, canvasHeight);
    }

    const offset = this.x / newScale;

    this.bonusMeter.visible = offset > -132;
    this.topBar.updateElementPositions(offset);
  },

  markMove: function(dot) {

    const trailBall = this.trailPool.getObject();
    trailBall.x = dot.x;
    trailBall.y = dot.y;
    trailBall.visible = true;
    trailBall.alpha = 1;
    trailBall.scale.set(this.activeBall.scale.x);

    this.add(trailBall);
    this.game.add.tween(trailBall).to({alpha: 0.9}, 2000, Phaser.Easing.Linear.None, true).onComplete.add(() => {
      trailBall.kill();
    });

  },

  fadeTrail: function() {

  },

  showDots: function(dots) {

    this.dots.clear();
    this.dots.beginFill(0x0000ff);
    dots.forEach((dot, idx) => {
      this.dots.drawCircle(dot.x, dot.y, 10);
    });
    this.dots.endFill();
  },


  _createMachineObjects: function() {

    // create cups, holes and other positions
    var mc = MachineConstants;
    const extractVertices = tag => {
      return this.game.cache.getJSON(tag).model.vertices[0].position.data.map(v => v*0.01);
    };
    const extractIndices = tag => {
      // for some reason we have to 'return' the result here, why?
      return this.game.cache.getJSON(tag).model.meshes[0].indices;
    };

    var cupRampSlope = mc.BACK_RAMP_SLOPE;
    var objects = {
      leftWall: mc.LEFT_OUTER_WALL,
      rightWall: mc.RIGHT_OUTER_WALL,
      leftRampWall: {
        position: mc.LEFT_RAMP_WALL
      },
      rightRampWall: {
        position: mc.RIGHT_RAMP_WALL
      },
      frontramp: {
        position: mc.FRONT_RAMP,
        rotation: {x: -(Math.PI/2-mc.FRONT_RAMP_SLOPE), y: 0, z: 0}
      },
      backramp: {
        position: mc.BACK_RAMP,
        rotation: {x: -(Math.PI/2-mc.BACK_RAMP_SLOPE), y: 0, z: 0}
      },
      backWall: {
        position: mc.BACK_WALL,
        rotation: {x: 0, y: 0, z: 0}
      },
      rampBlocker: {
        position: mc.RAMP_BLOCKER,
        rotation: {x: 0, y: 0, z: 0}
      },
      cups: {
        rotation: {x: cupRampSlope, y: 0, z: 0},
        obj: [
          {
            position: mc.CENTER_CUP,
            vertices: extractVertices(LogicCore.HOLE_TAG_CENTER),
            indices: extractIndices(LogicCore.HOLE_TAG_CENTER)
          },
          {
            position: mc.CENTER_UPPER_CUP,
            vertices: extractVertices(LogicCore.HOLE_TAG_CENTER_UPPER),
            indices: extractIndices(LogicCore.HOLE_TAG_CENTER_UPPER)
          },
          {
            position: mc.LARGE_CENTER_CUP,
            vertices: extractVertices(LogicCore.HOLE_TAG_LARGE_CENTER),
            indices: extractIndices(LogicCore.HOLE_TAG_LARGE_CENTER)
          },
          {
            position: mc.MIDDLE_TOP_CUP,
            vertices: extractVertices(LogicCore.HOLE_TAG_MIDDLE_TOP),
            indices: extractIndices(LogicCore.HOLE_TAG_MIDDLE_TOP)
          },
          {
            position: mc.LEFT_TOP_CUP,
            vertices: extractVertices(LogicCore.HOLE_TAG_UPPER_LEFT),
            indices: extractIndices(LogicCore.HOLE_TAG_UPPER_LEFT)
          },
          {
            position: mc.RIGHT_TOP_CUP,
            vertices: extractVertices(LogicCore.HOLE_TAG_UPPER_LEFT), // left & right meshes are the same
            indices: extractIndices(LogicCore.HOLE_TAG_UPPER_LEFT)
          },
          {
            position: mc.BIG_RING,
            vertices: extractVertices(LogicCore.HOLE_TAG_OUTER_RING),
            indices: extractIndices(LogicCore.HOLE_TAG_OUTER_RING),
            tag: LogicCore.HOLE_TAG_OUTER_RING
          }
        ]
      },
      holes: {
        obj: [
          {
            position: mc.CENTER_HOLE,
            tag: LogicCore.HOLE_TAG_CENTER
          },
          {
            position: mc.CENTER_UPPER_HOLE,
            tag: LogicCore.HOLE_TAG_CENTER_UPPER
          },
          {
            position: mc.LARGE_CENTER_HOLE,
            tag: LogicCore.HOLE_TAG_LARGE_CENTER
          },
          {
            position: mc.MIDDLE_TOP_HOLE,
            tag: LogicCore.HOLE_TAG_MIDDLE_TOP
          },
          {
            position: mc.LEFT_TOP_HOLE,
            tag: LogicCore.HOLE_TAG_UPPER_LEFT
          },
          {
            position: mc.RIGHT_TOP_HOLE,
            tag: LogicCore.HOLE_TAG_UPPER_RIGHT
          },
          {
            position: mc.BIG_RING_HOLE,
            tag: LogicCore.HOLE_TAG_OUTER_RING
          }
        ]
      }
    };

    //
    return objects;

  },

  _createPhysics: function(objects) {


    var mapChunk = function(obj) {
      return _.mapObject(obj, (val, key) => {
        if (key === 'position') {
          return viewPositionToPhysics(val);
        }
        else if (key === 'vertices') {
          return val.map(viewToPhysics);
        }
        return val;
      });
    };
    var bodyProto = _.mapObject(objects, (val, key) => {

      if (typeof val === 'number') {
        return viewToPhysics(val);
      }

      if (typeof val === 'object') {

        if (key === 'cups' || key === 'holes') {
          return _.mapObject(val, (val, key) => {

            if (key === 'rotation') {
              return val;
            }
            else if (key === 'obj') {
              return _.map(val, mapChunk);
            }

            return val;
          });
        }

        return mapChunk(val);
      }
    });


    // create the world, et al.
    return SkeeballPhysics.init(this.game, bodyProto);

  },

  _createCupsRings: function() {

    return [
      this._createCupLayer('backofTopCups.png', 50),
      this._createCupLayer(['backTopCups.png', 'backMidSm.png'], 100),
      this._createCupLayer('backofBgCenter.png', 40),
      this._createCupLayer('40Cup.png', 30),
      this._createCupLayer('centerCup.png', 20),
      this._createCupLayer('bigCenter.png', 10),
      this._createCupLayer('bigUfront.png', 0)
    ];
  },

  _createCupEffects: function() {

    const createAnimSprite = (x, y, value, scale) => {

      // create yellow glow anim over the cup
      const prefix = (value > 20) ? 'cupFx0' : value+'Efx0';
      const sprite = this.game.add.sprite(x, y, 'skee', prefix+'001.png', this);
      const animData = [
        {label: 'run', nameRoot: prefix, frame1: 1, frameLast: 13}
      ];
      AnimHelpers.addAnimationData(sprite, animData);

      // initial hide & scale
      sprite.scale.set(scale);
      sprite.visible = false;

      return sprite;
    };

    return [
      {points: 10, tag: LogicCore.HOLE_TAG_OUTER_RING, fx: createAnimSprite(0, 0, 10, 1.0)},
      {points: 20, tag: LogicCore.HOLE_TAG_LARGE_CENTER, fx: createAnimSprite(0, 0, 20, 1.0)},
      {points: 30, tag: LogicCore.HOLE_TAG_CENTER, fx: createAnimSprite(462, 139, 30, 1.0)},
      {points: 40, tag: LogicCore.HOLE_TAG_CENTER_UPPER, fx: createAnimSprite(466, 105, 40, 0.934)},
      {points: 50, tag: LogicCore.HOLE_TAG_MIDDLE_TOP, fx: createAnimSprite(476, 83, 50, 0.728)},
      {points: 100, tag: LogicCore.HOLE_TAG_UPPER_LEFT, fx: createAnimSprite(402, 83, 100, 0.728)},
      {points: 100, tag: LogicCore.HOLE_TAG_UPPER_RIGHT, fx: createAnimSprite(550, 83, 100, 0.728)}
    ];


    //20Efx0001.png
  },

  _createCupLayer: function(frame, value) {

    var layer = this.game.add.group(this);

    // add cups
    var frames = (frame instanceof Array) ? frame : [frame];
    frames.forEach(frameName => {

      // add cup(s)
      var x = (value === 30) ? -30 : 0;
      this.game.add.image(0, 0, 'skee', frameName, layer);
    });


    // add cup value
    if (value === 100) {
      // we need 2
      this.game.add.image(0, 0, 'skee', '100Label.png', layer);
      this.game.add.image(0, 0, 'skee', '100RLabel.png', layer);
    }
    else if (value) {
      this.game.add.image(0, 0, 'skee', value+'Label.png', layer);
    }

    return layer;
  },

  _createSparkleEffects: function() {

    // share one sparkle effect with all the cups
    this.cupSparkle = new CupSparkle(this.game);

    const createSparkleEffect = (x, y, depth) => {

      // add to correct cup layer at position 0
      return {x, y, layer: this.getAt(GameScreen.BASE_CUP_DEPTH+depth)};
    };

    return [
      {points: 10, tag: LogicCore.HOLE_TAG_OUTER_RING, fx: null},
      {points: 20, tag: LogicCore.HOLE_TAG_LARGE_CENTER, fx: createSparkleEffect(512, 215, 5)},
      {points: 30, tag: LogicCore.HOLE_TAG_CENTER, fx: createSparkleEffect(512, 218, 4)},
      {points: 40, tag: LogicCore.HOLE_TAG_CENTER_UPPER, fx: createSparkleEffect(512, 150, 3)},
      {points: 50, tag: LogicCore.HOLE_TAG_MIDDLE_TOP, fx: createSparkleEffect(512, 95, 1)},
      {points: 100, tag: LogicCore.HOLE_TAG_UPPER_LEFT, fx: createSparkleEffect(440, 116, 1)},
      {points: 100, tag: LogicCore.HOLE_TAG_UPPER_RIGHT, fx: createSparkleEffect(588, 116, 1)}
    ];

  },

  _createBonusCupEffects: function() {

    // share one sparkle effect with all the cups
    this.bonusCupShimmer = new BonusCupShimmer(this.game);

    const createShimmerEffect = (x, y, depth) => {

      // add to correct cup layer at position 0
      return {x, y, layer: this.getAt(GameScreen.BASE_CUP_DEPTH+depth)};
    };

    return [
      {points: 10, tag: LogicCore.HOLE_TAG_OUTER_RING, fx: createShimmerEffect(512, 260, 6)},
      {points: 20, tag: LogicCore.HOLE_TAG_LARGE_CENTER, fx: createShimmerEffect(512, 226, 5)},
      {points: 30, tag: LogicCore.HOLE_TAG_CENTER, fx: createShimmerEffect(512, 205, 4)},
      {points: 40, tag: LogicCore.HOLE_TAG_CENTER_UPPER, fx: createShimmerEffect(512, 150, 3)},
      {points: 50, tag: LogicCore.HOLE_TAG_MIDDLE_TOP, fx: createShimmerEffect(512, 115, 1)},
      {points: 100, tag: LogicCore.HOLE_TAG_UPPER_LEFT, fx: createShimmerEffect(440, 118, 1)},
      {points: 100, tag: LogicCore.HOLE_TAG_UPPER_RIGHT, fx: createShimmerEffect(588, 118, 1)}
    ];
  },

  _createBonusAwardPops: function() {

    const mult2 = this.game.add.group(this);
    this.game.add.image(0, 0, 'skee', '2label.png', mult2);
    this.game.add.image(55, 32, 'skee', 'xText.png', mult2);
    mult2.pivot.set(mult2.width/2, mult2.height/2);

    const mult4 = this.game.add.group(this);
    this.game.add.image(0, 0, 'skee', '4label.png', mult4);
    this.game.add.image(55, 32, 'skee', 'xText.png', mult4);
    mult4.pivot.set(mult4.width/2, mult4.height/2);

    const extraBall = this.game.add.group(this);
    this.game.add.image(0, 0, 'skee', 'extraText.png', extraBall);
    this.game.add.image(0, 40, 'skee', 'ballText.png', extraBall);
    extraBall.pivot.set(extraBall.width/2, extraBall.height/2);

    const extraBalls = this.game.add.group(this);
    this.game.add.image(0, 0, 'skee', '3label.png', extraBalls);
    this.game.add.image(85, 0, 'skee', 'extraText.png', extraBalls);
    this.game.add.image(85, 40, 'skee', 'ballsText.png', extraBalls);
    extraBalls.pivot.set(extraBalls.width/2, extraBalls.height/2);

    // hash by bonus event
    const bonusAwardPops = [
      {event: LogicCore.BONUS_EVENT_2X_MULTIPLIER, pop: mult2, ix: 270, iy: 160},
      {event: LogicCore.BONUS_EVENT_4X_MULTIPLIER, pop: mult4, ix: 280, iy: 160},
      {event: LogicCore.BONUS_EVENT_EXTRA_BALL, pop: extraBall, ix: 300, iy: 290, preSound: GameSounds.SOUND_GLITTER_AIR, sound: GameSounds.SOUND_EXTRA_BALL},
      {event: LogicCore.BONUS_EVENT_BONUS_BALLS, pop: extraBalls, ix: 512, iy: 410, sound: GameSounds.SOUND_BONUS_TURNS}
    ];
    bonusAwardPops.forEach(obj => {
      obj.pop.visible = false;
    });

    // listen for bonus events
    const initialDelay = 300;
    let popShowingDelay = initialDelay;
    this.game.logic.onSignalBonusEvent.add((bonusEvent) => {

      // find popup
      const bonusPop = _.findWhere(bonusAwardPops, {event: bonusEvent});
      if (bonusPop) {

        // might play a sound before popup shows
        if (bonusPop.preSound) {
          this.game.soundManager.playSound(bonusPop.preSound);
        }

        TimeHelpers.makeOneShotTimer(popShowingDelay, () => {


          const pop = bonusPop.pop;
          const ox = (this.game.sizeManager.isPortrait) ? 0 : (bonusPop.ix - 512);
          pop.scale.set(0.2);
          pop.x = 512 + ox;
          pop.y = bonusPop.iy;
          pop.alpha = 0;
          pop.visible = true;
          this.game.add.tween(pop.scale).to({x: 1, y: 1}, 800, Phaser.Easing.Elastic.Out, true);
          this.game.add.tween(pop).to({alpha: 1}, 200, Phaser.Easing.Linear.None, true);
          this.game.add.tween(pop).to({y: bonusPop.iy-50}, 1500, Phaser.Easing.Cubic.Out, true);

          // fx
          if (bonusPop.sound) {
            this.game.soundManager.playSound(bonusPop.sound);
          }

          TimeHelpers.makeOneShotTimer(1600, () => {
            this.game.add.tween(pop).to({alpha: 0}, 200, Phaser.Easing.Linear.None, true).onComplete.add(() => {
              pop.visible = false;
              popShowingDelay = initialDelay;
            });
          });
        });

      }

      // add a delay for next call - handles case where you get both a multiplier and a free ball
      popShowingDelay += 200;

    });

  },

  _swapBallDepth: function(newDepth) {


    // swap with rings or put back on top
    if (newDepth < 0) {
      this.bringToTop(this.activeBall);
    }
    else {
      this.addChildAt(this.activeBall, GameScreen.BASE_CUP_DEPTH+newDepth);
    }
  }



});

export default GameScreen;



// WEBPACK FOOTER //
// ./app/src/display/GameScreen.js